export default {
  SALARY_MANAGE: 'hr.salary_manage',
  SALARY_VIEW_ALL: 'hr.salary_view_all',
  SALARY_VIEW_PERSONAL: 'hr.salary_view_personal',
  SETTINGS_MANAGE_DEPARTMENTS: 'settings.manage_departments',
  SETTINGS_MANAGE_DEPARTMENT_SUPPLIERS: 'settings.manage_department_suppliers',
  SETTINGS_MANAGE_TABLETS: 'settings.manage_tablets',
  SETTINGS_MANAGE_INVENTORY: 'settings.manage_inventory',
  OPERATIONS_SPECIALDAYS_MANAGE: 'operations.specialdays_manage',
  OPERATIONS_SPECIALDAYS_VIEW: 'operations.specialdays_view',
  SHIFTS_VIEW_ALL_AREAS: 'shifts.view_all_areas',
  SHIFTS_APPROVE_SCHEDULE: 'shifts.approve_schedule',
  SHIFTS_ADJUST_FORECAST: 'shifts.adjust_forecast',
  SHIFTS_MANAGE_ENTRIES: 'shifts.manage_entries',
  SHIFTS_MANAGE_LOCKED_ENTRIES: 'shifts.manage_locked_entries',
  SHIFT_ENTRIES_VIEW: 'shifts.view_entries',
  SHIFT_ENTRIES_DELETE: 'shifts.delete_entry',
  SHIFTS_MANAGE_CHANGE_REQUESTS: 'shifts.manage_change_requests',
  SHIFTS_MANAGE_AUTO_CHECKOUTS: 'shifts.manage_auto_checkouts',
  VIEW_ADMIN_MENU: 'menu.view_admin',
  INVENTORY_MANAGE: 'inventory.manage',
  INVENTORY_ADJUST_ORDER_AMOUNT: 'inventory.order_adjust',
  INVENTORY_CAN_HANDLE_OFFSET_FOR_OFFICE: 'inventory.can_handle_offset_for_office',
  INVENTORY_CAN_HANDLE_OFFSET_FOR_DEPARTMENT: 'inventory.can_handle_offset_for_department',
  INVENTORY_ORDER_TABLET: 'inventory.order_tablet',
  INVENTORY_ORDER_ADMIN: 'inventory.order_admin',
  INVENTORY_ORDER_DELIVERY_DESKTOP: 'inventory.order.delivery_desktop',
  CHECKLIST_TEMPLATES_MANAGE: 'checklists.manage_templates',
  CHECKLISTS_MANAGE: 'checklists.manage',
  ONBOARDING_CHECKLIST_TEMPLATES_MANAGE: 'onboarding.checklists.manage_templates',
  ONBOARDING_CHECKLISTS_MANAGE: 'onboarding.checklists.manage',
  DASHBOARD_FULL: 'dashboard.full',
  DASHBOARD_PERSONAL: 'dashboard.personal',
  DASHBOARD_TABLET: 'dashboard.tablet',
  CLEANING_CHECKUPS_MANAGE: 'cleaning_checkups.manage',
  CONTRACTS_VIEW: 'app.hr.contracts',
  CONTRACTS_MANAGE: 'contracts.manage',
  EMPLOYMENTS_CREATE_USER_WITHOUT_CONTRACT: 'employments.create_user_without_contract',
  EMPLOYMENTS_VIEW_USERS: 'employments.view_users',
  EMPLOYMENTS_MANAGE_USERS: 'employments.manage_users',
  EMPLOYMENTS_MANAGE_USERS_FULL: 'employments.manage_users_full',
  EMPLOYMENTS_MANAGE_USER_AVATAR: 'employments.manage_user_avatar',
  HR_MANAGE_AMO: 'hr.manage_amo',
  FINANCIALS_MANAGE: 'financials.manage',
  SHIFTS_EXCHANGE_MANAGE: 'shifts.exchange_manage',
  FINANCIALS_PERFORMANCE_VIEW: 'financials.performance_view',
  EMPLOYMENTS_CREATE_EMPLOYMENT: 'employments.create_employment',
  EMPLOYMENTS_CHANGE_EMPLOYMENT: 'employments.change_employment',
  EMPLOYMENTS_UPDATE_EMPLOYMENT: 'employments.update_employment'
}
